import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';

import { load } from 'modules/Common/reducers/morenews';
import { loadMediaForArticles } from 'modules/Common/reducers/media';
import MoreNewsList from 'modules/News/components/MoreNewsList';

const INITIAL_PAGE_SIZE = 12;

@layoutAsyncConnect(
  'MoreNews',
  [{
    dispatch: ({pathname}) => load(pathname, INITIAL_PAGE_SIZE + 1),
    // no state - not needed here, MoreNewsList @connects
    then: ({dispatch, state, result: {articles}}) => loadMediaForArticles(state, dispatch, articles)
  }]
)

@catchLifeCycleErrors
export default class MoreNews extends Component {
  static propTypes = {
    location: PropTypes.object
  };

  render() {
    const { location } = this.props;

    return <MoreNewsList
      basketQuery={{ key: "basketPath", value: location.pathname }}
      initialPageSize={INITIAL_PAGE_SIZE}
    />
  }
}



// WEBPACK FOOTER //
// ./modules/News/containers/MoreNews.js